import { useEffect, useState } from 'react';

// TW4 default breakpoints (unchanged from TW3's tailwindcss/defaultTheme).
// Hard-coded because TW4 has no JS-importable defaultTheme.
const screens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
} as const;

export type TailwindScreenKey = keyof typeof screens;

export const useBreakpoint = (screenKey: TailwindScreenKey) => {
  const query = `(min-width: ${screens[screenKey]})`;
  const getMatches = (query: string): boolean => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  };

  const [matches, setMatches] = useState<boolean>(getMatches(query));

  useEffect(() => {
    const handleChange = () => {
      setMatches(getMatches(query));
    };

    const matchMedia = window.matchMedia(query);

    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};
